/**
 * @desc 新增
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<defs.appCenter.ViewTableResponseDto>;
export function request(
  body: defs.appCenter.ViewTableRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/viewTable/add`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
